import './News.css';
import NewsPanel from './NewsPanel/NewsPanel';
import './NewsPanel/NewsPanel';
import { Helmet } from 'react-helmet';

import { useEffect } from "react";

export default function News({ renderNews, news, setNewsPage }) {
    useEffect(() => {
        renderNews(1, 100);
    }, []);

    return (
        <section id="news" className='news'>
            <Helmet>
                <title>Акции и новости</title>
            </Helmet>
            <ul className='news__list'>
            {news.map((item) => (<NewsPanel 
                key={item.metadata.uid}
                item={item}
                setNewsPage={setNewsPage}
            />))}
            </ul>
        </section>
    )
}
